import { createActions } from 'redux-actions'

import { identityAction } from '@/utils/actions'

export const {
  ratingWidget: {
    viewedJobs: setViewedJobs,
    addViewedJob,
    show: showWidget,
    enabled: setWidgetEnabled,
    renderRatingWidget,
    renderRatingWidgetAfterTimeout
  }
} = createActions({
  RATING_WIDGET: {
    VIEWED_JOBS: identityAction,
    ADD_VIEWED_JOB: identityAction,
    SHOW: identityAction,
    ENABLED: identityAction,
    RENDER_RATING_WIDGET: null,
    RENDER_RATING_WIDGET_AFTER_TIMEOUT: null
  }
})
